import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 엔젤리그 조합원 자격 거래 이용약관 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 조합원 자격 거래를 위해 이용약관에 동의해주세요. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 전체 동의 ")
const _hoisted_5 = { class: "agree-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_toggle_icon = _resolveComponent("ag-toggle-icon")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_img = _resolveComponent("ag-img")!

  return (_openBlock(), _createBlock(_component_ag_box, {
    p: "8px 20px 0px 20px",
    dp: "flex",
    "justify-content": "space-between",
    direction: "column"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ag_text, {
          "margin-bottom": '8px',
          dp: 'block',
          typography: 'tit20b'
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_ag_text, {
          color: 'gray3',
          typography: 'main14r'
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_ag_box, {
          style: _normalizeStyle([{"border-radius":"10px"}, _ctx.agreeAll ? 'border: 1px solid #4360EC' : 'border : 1px solid #D9DEE8']),
          p: "16px",
          dp: "flex",
          "align-items": "center",
          mt: "90px",
          onClick: _ctx.actAgreeAll
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_toggle_icon, {
              name: "check",
              value: _ctx.agreeAll
            }, null, 8, ["value"]),
            _createVNode(_component_ag_text, {
              "padding-left": "6px",
              typography: 'list16m'
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style", "onClick"]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agreeList, (agree, idx) => {
            return (_openBlock(), _createBlock(_component_ag_box, {
              key: (agree, idx),
              "align-items": "center",
              dp: "flex",
              m: "24px 16px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_toggle_icon, {
                  style: {"flex-shrink":"0"},
                  name: "check",
                  value: _ctx.agreeList[idx].value,
                  onClick: () => _ctx.agreeList[idx].value = !_ctx.agreeList[idx].value
                }, null, 8, ["value", "onClick"]),
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  "justify-content": "space-between",
                  width: "100%",
                  "align-items": "center",
                  onClick: ($event: any) => (_ctx.openLink(_ctx.agreeList[idx].link))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      "padding-left": "10px",
                      typography: 'main16r'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(agree.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ag_img, {
                      width: "30px",
                      height: "30px",
                      style: {"flex-shrink":"0"},
                      src: "/assets/icon/btn_right_g.png"
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}